namespace GeniuzPOS.Inventory {
    export class IcTranTypeColumns {
        static columnsKey = 'Inventory.IcTranType';
    }
}
